/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { currencyFormat, currencyFormatInt, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import ReportModal from "../../ReportModal";
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../Icons/Date";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import customStyles from "../../../../../assets/styles/customStyles";
import { getRequest } from '../../../../../helpers/axiosClient';
import { Button, Box } from "@mui/material";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';
import groupActions from "../../../../Sales/Setup/redux/actions";
import salesActions from "../../../../Sales/Management/redux/actions";
import moment from 'moment';

export const CustomerLeaderBoard = (props) => {
    const { visible, onLeaderBoardVisible, title, onMenuTitle } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const [leaderBoard, setLeaderBoard] = useState([]);
    const [reportOpen, setReportOpen] = useState(false);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const [form, setForm] = useState({
        startDate: new Date(),
        endDate: new Date()
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const onChangeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'customerId') {
                setForm({
                    ...form,
                    'groupId': '',
                    [name]: e,
                });
            } else if (name === 'groupId') {
                setForm({
                    ...form,
                    [name]: e,
                    'customerId': ''
                });
            } else {
                setForm({
                    ...form,
                    [name]: e
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    useEffect(() => {
        if (visible) {
            dispatch({
                type: groupActions.CUSTOMERGROUP_DETAILS_START, url: 'customer-group', filter: {
                    order: 'id  desc'
                }
            });
            customerApi();
        }
    }, [visible])


    const customerApi = (search = '', id = '') => {
        let filter = { or: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    const leaderBoardFilter = (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            let url = `${process.env.REACT_APP_API_URL}/customerInvoiceReport?startDate=${moment(form?.startDate).format("YYYY-MM-DD")}&endDate=${moment(form?.endDate).format("YYYY-MM-DD")}`;

            if (form?.customer?.id) {
                url += `&customerId=${form?.customer?.id}`;
            }

            if (form?.group?.id) {
                url += `&groupId=${form?.group?.id}`;
            }

            let response = getRequest(url);
            response.then(payload => {
                setLeaderBoard(payload.data);
                setReportOpen(true);
                setLoading(false);
            }).catch(error => {
                // Handle any errors
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }

    }

    const leaderBoardTitle = (form) => {
        let title = '';
        if (form?.customer?.id) {
            title = 'Customer Name: ' + form?.customer?.name;
        }
        if (form?.group?.id) {
            title += 'Group Name: ' + form?.group?.name;
        }
        return title;
    }

    const leaderBoardDate = (form) => {
        let title = '';
        if (form?.startDate) {
            title = 'From Date: ' + moment(form?.startDate).format("DD/MM/YYYY");
        }
        if (form?.endDate) {
            title += ' To Date: ' + moment(form?.endDate).format("DD/MM/YYYY");
        }
        return title;
    }

    const handleClose = () => {
        onLeaderBoardVisible(false);
        onMenuTitle('');
    }

    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => leaderBoardFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <div className={clsx(classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={form?.startDate}
                                        format='dd/MM/yyyy'
                                        label="Start Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('Start Date', 'customerLeaderBoard', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ?
                                                onChangeHandler(new Date(), 'startDate') :
                                                onChangeHandler(newValue, 'startDate')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={form?.endDate}
                                        format='dd/MM/yyyy'
                                        label="End Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('End Date', 'customerLeaderBoard', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ?
                                                onChangeHandler(new Date(), 'endDate') :
                                                onChangeHandler(newValue, 'endDate')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <AutoCompleteComponent
                                name={["Customer Name "]}
                                heads={[{ 'key': 'name', 'name': 'Customer Name' },
                                { 'key': 'mobile', 'name': 'Phone Number' },
                                { 'key': 'serialNo', 'name': 'Customer ID' }]}
                                details={customerDetails}
                                id={idNamingConversion('Customer Name', 'customerLeaderBoard', 'DropDown')}
                                parentValue={customObject(customerDetails, form?.customer?.id)}
                                onChange={(data) => onChangeHandler(data, 'customer')}
                                position={"bottom"}
                                searchType={(s) => customerApi(s)}
                                customClasses={classes.margin20t}
                            />
                            <AutoCompleteComponent
                                name={["Group Name"]}
                                heads={[{ 'key': 'name', 'name': 'Name' },
                                { 'key': 'description', 'name': 'Description' }]}
                                details={customerGroupdetails}
                                id={idNamingConversion('Group Name', 'customerLeaderBoard', 'DropDown')}
                                parentValue={customObject(customerGroupdetails, form?.group?.id)}
                                onChange={(data) => onChangeHandler(data, 'group')}
                                position={"bottom"}
                                customClasses={classes.margin20t}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: loading })}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{title}</h4>
                            <p className={classes.downloadsHeading}>{leaderBoardDate(form)}</p>
                            <p className={clsx(classes.downloadsHeading)} style={{ marginTop: '10px' }}>{leaderBoardTitle(form)}</p>
                        </div>
                        <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                            <Col span={4}><h6>Cust. Name</h6></Col>
                            <Col span={4}><h6>Cust. ID</h6></Col>
                            <Col span={6}><h6 className={classes.textAlignRight}>Invoice Amount</h6></Col>
                            <Col span={5}><h6 className={classes.textAlignRight}>Balance Due</h6></Col>
                            <Col span={5} ><h6 className={classes.textAlignRight}>Payment Settled</h6></Col>
                        </Row>
                        {
                            leaderBoard.length > 0 ? leaderBoard.map((data, i) => (
                                <Row className={clsx(classes.bill, 'no-break')}>
                                    <Col span={4}><p>{data.customerName}</p></Col>
                                    <Col span={4}><p>{data.customerId}</p></Col>
                                    <Col span={6} className={classes.textAlignRight}><p>₹ {currencyFormatInt(data.totalInvoiceAmount)}</p></Col>
                                    <Col span={5} className={classes.textAlignRight}><p>₹ {currencyFormat(data.totalBalance)}</p></Col>
                                    <Col span={5} className={classes.textAlignRight}><p>{`₹ ${currencyFormatInt(data.totalSettledAmount)}`}</p></Col>
                                </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                        }
                        <Row className={clsx(classes.bill)}>
                            <Col span={4}></Col>
                            <Col span={4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total:</h6></Col>
                            <Col span={6} className={classes.textAlignRight}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>{`₹ ${currencyFormatInt(leaderBoard?.length > 0 ? leaderBoard.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.totalInvoiceAmount || 0), 0) : 0)}`}</h6></Col>
                            <Col span={5} className={classes.textAlignRight}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>{`₹ ${currencyFormat(leaderBoard?.length > 0 ? leaderBoard.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.totalBalance || 0), 0) : 0)}`}</h6></Col>
                            <Col span={5} className={classes.textAlignRight}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>{`₹ ${currencyFormatInt(leaderBoard?.length > 0 ? leaderBoard.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.totalSettledAmount || 0), 0) : 0)}`}</h6></Col>

                        </Row>
                    </>
                }
                businessDetails={businessDetails}
                handleClose={() => { setReportOpen(false); setLeaderBoard([]) }}
            />
        </>
    )
}